import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function ContentLoader() {
  return (
    <div className="ContentLoader">
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          left: 0,
          right: 0,
          top: 0,
          background: 'rgba(255, 255, 255, 0.75)',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 99,
          height: '100%',
          '& > :not(style)': {
            m: 1
          }
        }}
      >
        <CircularProgress />
      </Box>
    </div>
  );
}
